import React, { Component } from 'react'
import { Tab, Tabs } from "react-bootstrap";
import { GET_FLITER_ID, showAddAccountAlertNew } from '../../../../../../utils';
import InputField from '../Elements/InputField';
import CheckBoxField from '../Elements/CheckboxField';
import NeedHelp from '../Elements/NeedHelp';
import { connect } from 'react-redux';
import { getInitialRoute, isAppleSafari } from '../../../../../../utils';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import AccountPicker from '../Elements/AccountPicker';
import { createFeedAction } from '../../../../../../actions/addFeedActions';
import { addUserAccount } from '../../../../../Authorization/SocialAuth/connectSocialAcc';


const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class Vimeofeed extends Component {
    state = {
        hashtag: "",
        handle: "",
        manuallyApprove: false,
        error: false,
        handleError: false,
        filterType: 'Hashtag',
        filterId: 2,
        authRequired: null,
        connetedAccount: null,
        authenticate: false,
        loading: false,
        errorMsg: 'This field is required',
    }

    componentDidMount() {
        this.setState({ authRequired: this.props.feedInfo[0].authRequire })
        this.props.onFilterNameChange(this.state.filterType);
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false })
    onManuallyApproveChange = (value) => this.setState({ manuallyApprove: value })
    onConnectedAccountChange = (value) => this.setState({ connetedAccount: value })
    onAuthenticateChange = (value) => this.setState({ authenticate: value })

    onSubmit = () => {
        const { hashtag, handle, authRequired, filterId, connetedAccount} = this.state;

        if ((!hashtag || hashtag == "") && filterId == 2){
            this.setState({ error: true })
        }else if((!handle || handle == "") && filterId == 1){
            this.setState({ handleError: true })
        } else {
            if(connetedAccount == null){
                if(authRequired){
                    this.onAddAccount();
                }else{
                    this.onAddFeed(null);
                }
            }else{
                this.onAddFeed(null);
            }
        }
    }


    onAddAccount = () => {
        showAddAccountAlertNew({id:8,name:"vimeo"},"addFeed");
    }


    onAddFeed = (connectAccountId) => {
        const { hashtag,handle, manuallyApprove, filterId, connetedAccount } = this.state
        const { navigation, hideAddfeed, wallId } = this.props
        var obj = {
            wallId: wallId,
            networkId: 8,
            filter: filterId,
            moderation: manuallyApprove,
            feedText: '',
            accountId: connectAccountId ? connectAccountId: connetedAccount,
        }
          if(filterId == 2){
            obj['feedText'] = hashtag.split('#').join('');
          }else if(filterId == 1){
            obj['feedText'] = handle.split('@').join('');
          }
        this.setState({loading: true , error:false, handleError:false});
       
        createFeedAction(obj,8,(feedId)=>this.setState({loading:false},()=>{
            if(feedId){
                navigation(`/moderation/index/${wallId}`);
                hideAddfeed();
            }
        }));

    }

    needSupportLinks = (filterType) => {
        if (getInitialRoute() === 'widget') {
            switch (filterType) {
                case 'Hashtag':
                    return ['https://player.vimeo.com/video/704419775', 'https://taggbox.com/support/how-to-embed-vimeo-widget-on-website/']
                case 'Handle':
                    return ['https://player.vimeo.com/video/704419681', 'https://taggbox.com/support/how-to-embed-vimeo-widget-on-website/']
                default:
                    return ['https://player.vimeo.com/video/704419775', 'https://taggbox.com/support/how-to-embed-vimeo-widget-on-website/']
            }
        } else {
            switch (filterType) {
                case 'Hashtag':
                    return ['https://vimeo.com/537139964/6b744e124a', '']
                case 'Handle':
                    return ['https://vimeo.com/541612229/8d2b75ba2a', '']
                default:
                    return ['https://vimeo.com/537139964/6b744e124a', '']
            }
        }
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;
        if (type == "addFeed") {
            addUserAccount(networkId, data, (accountId) => this.onAddFeed(accountId), localStorage.getItem('ownerId'));
        }
    }


    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }


    render() {
        const { hashtag, handle,errorMsg, manuallyApprove, error, handleError, filterType, connetedAccount, loading } = this.state

        const { feedInfo, connectedAcc, } = this.props
        return (
            <div className="form-body create_feed_wt">
                <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details createFeedInsta personalizePopup">
                    <Tabs defaultActiveKey="Hashtag" id="PinterestFeedTab" value={filterType} className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3" onSelect={e => this.setState({ filterType: e, filterId: GET_FLITER_ID(e, feedInfo) }, () => { this.props.onFilterNameChange(e)})}>
                        <Tab eventKey={'Hashtag'} key={'Hashtag'} className="nav-link className= p-0" title={<span>{'Hashtag'}</span>}>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className={`fas fa-hashtag`}></i>
                                        </span>
                                    </div>
                                    <InputField name={"hashtag"} id='vimeo_hashtag' autoComplete={true} className={`autosearch mycheck form-control`} placeholder="Enter hashtag" value={hashtag} onChangeHandler={(e) =>this.onTextChange(e)} />
                                </div>
                                {error ? <span id="feedsfield2error" className="errorMessage required">{errorMsg}</span> : null}
                            </div>
                            <div className="hideforBSearch">
                                <div className="checkbox-inline">
                                    <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_hashtag" />
                                </div>
                            </div>

                            {connectedAcc && connectedAcc.length ? <AccountPicker connectedAcc={connectedAcc} networkId={'8'} onConnectedAccountChange={this.onConnectedAccountChange} connetedAccount={connetedAccount} /> : null}
                        </Tab>
                        <Tab eventKey={'Handle'} key={'Handle'} className="nav-link className= p-0" title={<span>{'Handle'}</span>}>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className={`fas fa-at`}></i>
                                        </span>
                                    </div>
                                    <InputField name={"handle"} id='vimeo_handle' autoComplete={true} className={`autosearch mycheck form-control`} placeholder="Enter user handle" value={handle} onChangeHandler={(e) =>  this.onTextChange(e)} />
                                </div>
                                {handleError ? <span id="feedsfield2error" className="errorMessage required">{errorMsg}</span> : null}
                            </div>
                            <div className="hideforBSearch">
                                <div className="checkbox-inline">
                                    <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_handle" />
                                </div>
                            </div>

                            {connectedAcc && connectedAcc.length ? <AccountPicker connectedAcc={connectedAcc} networkId={'8'} onConnectedAccountChange={this.onConnectedAccountChange} connetedAccount={connetedAccount} /> : null}
                        </Tab>
                    </Tabs>
                </div>
                <div className="form-actions w-100">
                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={this.needSupportLinks(filterType)[0]} supportLink={this.needSupportLinks(filterType)[1]} />
                        <SubmitFeedRequest onSubmit={this.onSubmit} onBack={this.props.onBack} loading={loading} />
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        connectedAcc: state.addFeedReducer.connectedAcc
    }
}


export default connect(mapStateToProps, null)(Vimeofeed)